<template>
  <div class="autobookpro-page-content">
    <div style="width: 90%" class="q-mx-auto q-mt-md">
      <div class="row justify-between items-center q-mb-sm">
        <app-select-input
          text="Type"
          v-model="marketingType"
          :options="marketingTypeOptions"
          option-label="label"
          option-value="value"
        />
        <div>
          <q-btn
            v-if="canCreateMarketing"
            color="primary"
            label="Create"
            :to="{
              name: 'create-marketing',
              query: { type: marketingType.value }
            }"
          />
        </div>
      </div>

      <q-table
        class="q-mt-md"
        flat
        bordered
        :loading="loading"
        :data="marketings"
        :columns="columns"
        :rows-per-page-options="[10, 15, 20]"
        binary-state-sort
      >
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="name" :props="props">
              {{ props.row.name }}
            </q-td>
            <q-td key="senderUser" :props="props">
              {{props.row.senderUser
                ? `${props.row.senderUser.firstName} ${props.row.senderUser.lastName}`
                : ''}}
            </q-td>
            <q-td key="emailTemplate" :props="props">
              {{ props.row.emailTemplate ? props.row.emailTemplate.name : '' }}
            </q-td>
            <q-td key="smsTemplate" :props="props">
              {{ props.row.smsTemplate ? props.row.smsTemplate.name : '' }}
            </q-td>
            <q-td key="baseDate" :props="props">
              {{ BASE_DATE_OPTIONS[props.row.baseDate] }}
            </q-td>
            <q-td key="days" :props="props">
              {{ props.row.days }}
            </q-td>
            <q-td key="hours" :props="props">
              {{ props.row.hours }}
            </q-td>
            <q-td key="actions" :props="props">
              <q-btn
                v-if="canUpdateMarketing"
                dense
                outline
                color="primary"
                size="sm"
                icon="edit"
                :to="{
                  name: 'marketing-detail',
                  params: { id: props.row.id },
                  query: { type: marketingType.value }
                }"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import graphql from '@client/graphql';
import AppSelectInput from '@client/components/form/select-input';
import {
  QUOTE_MARKETING_TYPE,
  ORDER_MARKETING_TYPE,
  MARKETING_TYPES,
  BASE_DATE_OPTIONS
} from '@server/constants/marketing';
import { assessPermission } from '@server/lib/permission-helpers';

const marketingTypeOptions = [
  {
    label: MARKETING_TYPES[QUOTE_MARKETING_TYPE],
    value: QUOTE_MARKETING_TYPE
  },
  {
    label: MARKETING_TYPES[ORDER_MARKETING_TYPE],
    value: ORDER_MARKETING_TYPE
  }
];

export default {
  components: {
    AppSelectInput
  },
  data() {
    return {
      marketingType: marketingTypeOptions[0],
      marketingTypeOptions,
      BASE_DATE_OPTIONS,

      columns: [
        {
          name: 'name',
          label: 'Name',
          align: 'left',
          sortable: true
        },
        {
          name: 'senderUser',
          label: 'Sender User',
          align: 'left'
        },
        {
          name: 'emailTemplate',
          label: 'Email',
          align: 'left'
        },
        {
          name: 'smsTemplate',
          label: 'SMS',
          align: 'left'
        },
        {
          name: 'baseDate',
          label: 'Base Date',
          align: 'center'
        },
        {
          name: 'days',
          label: 'Days',
          align: 'center'
        },
        {
          name: 'hours',
          label: 'Hours',
          align: 'center'
        },
        {
          name: 'actions',
          label: '',
          align: 'center'
        }
      ],
      loading: false
    };
  },
  computed: {
    canCreateMarketing() {
      return assessPermission.marketing.canCreate(this.currentUser);
    },
    canUpdateMarketing() {
      return assessPermission.marketing.canUpdate(this.currentUser);
    }
  },
  apollo: {
    currentUser: {
      query: graphql.queries.currentUser
    },
    marketings: {
      query: graphql.queries.getMarketings,
      variables() {
        return {
          type: this.marketingType.value
        };
      },
      watchLoading(isLoading) {
        this.loading = isLoading;
      },
      fetchPolicy: 'cache-and-network'
    }
  }
};
</script>

<style></style>
